"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractLanguage = extractLanguage;
exports.resolveDefaultExports = resolveDefaultExports;
/**
 * Convert "da-DK" to "da"
 *
 * We support languages and regions. This means loader keys might have different formats (e.g. "en", "en-US").
 * This utility function helps load the fallback translation messages in the language format.
 * For example, if "en-US" locale doesn't exist we fallback to "en" language.
 */
function extractLanguage(language) {
    const [result] = language.split('-');
    return result;
}
function resolveDefaultExports(languageFile) {
    if (typeof languageFile.default === 'object') {
        return languageFile.default;
    }
    return languageFile;
}
//# sourceMappingURL=helpers.js.map